import { Link } from 'react-router-dom';

const SHORTCUTS = [
  {
    to: '/movies',
    title: '电影',
    subtitle: '最新大片 · 高分佳作',
    desc: '动作、科幻、爱情、悬疑等全类型电影，按年份与地区自由筛选。',
    icon: 'ri-film-line',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20movie%20theater%20interior%20with%20rows%20of%20deep%20navy%20blue%20seats%20and%20a%20large%20glowing%20screen%20warm%20orange%20projector%20light%20beams%20through%20darkness%20elegant%20atmospheric%20moody%20premium%20cinema%20photography%20blue%20and%20orange%20tones&width=900&height=560&seq=cat-movie-01&orientation=landscape',
  },
  {
    to: '/tvshows',
    title: '电视剧',
    subtitle: '热播剧集 · 连载追更',
    desc: '国产剧、美剧、韩剧、日剧一网打尽，关注季数与类型标签。',
    icon: 'ri-live-line',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20at%20night%20with%20a%20large%20television%20screen%20glowing%20warm%20orange%2C%20deep%20navy%20blue%20ambient%20lighting%2C%20soft%20sofa%20and%20cushions%2C%20cinematic%20atmospheric%20interior%20photography%2C%20premium%20editorial%20style%2C%20blue%20and%20orange%20color%20scheme&width=900&height=560&seq=cat-tv-01&orientation=landscape',
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-8">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
        {SHORTCUTS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="group relative block h-[220px] overflow-hidden rounded-xl border border-background-200 md:h-[260px]"
          >
            <img
              src={item.image}
              alt={item.title}
              title={`${item.title} - 星辰影院`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/70 to-primary-950/25" />
            <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-8">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                    {item.title}
                  </h3>
                  <p className="text-xs tracking-wide text-accent-300">{item.subtitle}</p>
                </div>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">{item.desc}</p>
              <span className="mt-5 flex w-fit items-center gap-1.5 text-sm font-semibold text-background-50">
                进入分类
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}